module.exports = __webpack_public_path__ + "static/media/SF-1-A (1).d1cb17c3.mp3";